<script>
    import { Bar } from 'vue-chartjs'

    export default {
        extends: Bar,

        props: {
            dateRanges: {
                type: Object,
                required: true
            }
        },

        data: () => ({
            loading: false,
            chartdata: {
                labels: [],
                datasets: [
                    {
                        label: 'Lead Time Delivery',
                        backgroundColor: '#64cdca',
                        data: []
                    }
                ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
            }
        }),

        watch: {
            dateRanges: {
                deep: true,
                handler({fromDate, toDate}) {
                    this.load({fromDate, toDate})
                }
            }
        },

        async mounted () {
            try {
                await this.load(this.$props.dateRanges)
            } catch (e) {

            }
        },

        methods: {
            async load({fromDate, toDate}) {
                this.loading = true

                try {
                    const { data } = await axios.get(`/reports/lead-time`, {
                        params: {
                            from_date: fromDate,
                            to_date: toDate
                        }
                    })

                    const labels = [];
                    const items = [];

                    Object.keys(data.data).forEach((rangeTitle) => {
                        labels.push(`${rangeTitle}, ${data.data[rangeTitle]} รายการ`)
                        items.push(data.data[rangeTitle])
                    })

                    this.chartdata.labels = labels
                    this.chartdata.datasets[0].data = items

                    this.renderChart(this.chartdata, this.options)

                } catch (e) {
                    //
                }

                this.loading = false
            }
        }
    }
</script>
